var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPeoplePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 16.6667C19.055 16.6667 21.6667 14.055 21.6667 10.8333C21.6667 7.61168 19.055 5 15.8333 5C12.6117 5 10 7.61168 10 10.8333C10 14.055 12.6117 16.6667 15.8333 16.6667Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.1667V34.1667M25 29.1667H35",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23.3333H15.6667C11.933 23.3333 10.0662 23.3333 8.64008 24.0598C7.38565 24.699 6.36578 25.7189 5.72663 26.9733C5 28.3994 5 30.2663 5 33.9999V34.9999H22.5",
    stroke: "currentColor",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeoplePlus);
export default __webpack_public_path__ + "static/media/icon-people-plus.72a829ff88d18b20f26bfd3551fe78f7.svg";
export { ForwardRef as ReactComponent };